import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { User } from "../types";

interface AdminRouteProps {
  user: User | null;
}

const AdminRoute = ({ user }: AdminRouteProps) => {
  // 1. 未ログインならログイン画面へ
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // 2. ログイン済みだが、管理者権限がない場合はトップ画面へ強制送還
  if (!user.is_admin) {
    return <Navigate to="/" replace />;
  }

  // 3. 管理者ならそのまま表示
  return <Outlet context={user} />;
};

export default AdminRoute;
